Common.fullheight = () => {
	const $window = $(window);
	const $fullHeights = $('.gl-v1-fullheight');

	const reCalc = () => $fullHeights.css('min-height', $window.height())
	$window.on('resize', reCalc)
	reCalc()
	$fullHeights.addClass('fullheight-on')
}
